import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AliwangwangFilledSvg from "@ant-design/icons-svg/es/asn/AliwangwangFilled";
import AntdIcon from "../components/AntdIcon";
var AliwangwangFilled = function AliwangwangFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: AliwangwangFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  AliwangwangFilled.displayName = 'AliwangwangFilled';
}
export default /*#__PURE__*/React.forwardRef(AliwangwangFilled);